import React, { FC } from 'react';
import { SelectProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { AgentLeadStatus } from '~/types/AgentLead';
import Select from './Select';

const status: Record<string, AgentLeadStatus> = {
  new: 'NEW',
  contacted: 'CONTACTED',
  terminated: 'TERMINATED',
  converted: 'CONVERTED',
};

const LeadStatusSelect: FC<SelectProps<string>> = (props) => {
  const { t } = useTranslation('leadStatus');
  const options = Object.values(status).map((value: any) => ({
    label: t(value),
    value,
    key: value,
  }));

  return <Select showSearch options={options} {...props} />;
};

export default LeadStatusSelect;
